import { SafetyLocalStorage } from '@mail-core/std/storage';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';

export const safetyLocalStorage = new SafetyLocalStorage({
    keyPattern: (key) => `${USER_EMAIL}:${key}`,
});
